export default __webpack_public_path__ + "static/media/shield_1962520.ff2d3b53.svg";